import React, { Component } from 'react';
import $ from 'jquery';
import Message from './ValidationMessage';
import InlineField from './InlineField';

export class DropdownMultipleField extends Component {

  refresh() {
    $(`.ui.dropdown.renderDropDownMultiple`).dropdown({
      forceSelection: false
    });
  }

  render() {

    let {
      intl,
      translation,
      meta: { touched, error, warning },
      input,
      id,
      idField = 'id',
      displayField = 'name',
      activeOnly = true,
      required,
      label,
      disabled,
      displayType="edit",
      list = [],
      link,
    } = this.props;

    if (intl && translation) {
      const labelObj = translation.label;
      if(labelObj && labelObj.message) {
        label = intl.formatMessage(labelObj.message, labelObj.params);
      }
    }
    
    let content = [];

    const showError = touched && error ? 'error' : '';
    const requiredClass = required ? 'required' : '';
    const disabledClass = disabled ? 'disabled' : '';    
    const name = input ? input.name : '';
    if (!Array.isArray(input.value)) {
      input.value = [input.value];
    }

    // //filter active list
    // if (activeOnly) {
    //   list = _.reject(list, function (item) { return item.active === false; });
    // }

    const optionList = list.reduce((accumulator = [], item) => {
      if (item) {
        const idVal = item[idField];
        if (idVal != null) {
          const optionId = idVal;
          const optionValue = idVal;
          const optionLabel = item[displayField];

          const inputValues = input && input.value;
          inputValues.forEach((input) => {
            if(input === optionValue){
              content.push(optionLabel);
            }
          });

          if (activeOnly) {
            if (!item.hasOwnProperty('active') || item.active) {
              accumulator.push((
                <option key={optionId} value={optionValue}>{optionLabel}</option>
              ));
            }
          }
          else {
            accumulator.push((
              <option key={optionId} value={optionValue}>{optionLabel}</option>
            ));
          }
        }
      }
      return accumulator;
    }, []);

    if( displayType === "inline" ){
      return (
        <InlineField fieldType='renderDropdownMultipleField' value={ input.value } link={ link } docType={ ( list[0] || {} ).doc_type } content={ content } label={label} id={id} />
      );
    }

    return (
      <div className={`${requiredClass} ${disabledClass} field ${showError}`}>
        <label>{label}</label>
        <select {...input} className={`ui fluid multiple selection search dropdown renderDropdownMultiple`} multiple name={name} id={id}>
          {optionList}
        </select>
        <Message show={touched} message={error} />
        <Message show={touched} message={warning} />
      </div>
    );
  }
}
